import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/lab-procedures/creatinine";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	creatinine: {
		id: "form.creatinine",
		defaultMessage: "Kreatinin"
	},
	value: {
		id: "form.creatinine.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "creatinine",
	value: {
		title: messages.creatinine,
		validator,
		fieldset,
		isImportant: true
	}
};
